import { createAction } from "@reduxjs/toolkit";
import { FileProgressLoaderProps } from "../../components/loader/models";

export namespace LoaderActions {
  export enum ActionTypes {
    setFileLoader = "Set File Loader",
    setDefaultLoader = "Set Default Loader",
    clearLoader = "Clear Loader",
  }

  export const clearLoader = createAction(ActionTypes.clearLoader);
  export const setDefaultLoader = createAction(ActionTypes.setDefaultLoader);

  export const setFileLoader = createAction<
    FileProgressLoaderProps,
    ActionTypes.setFileLoader
  >(ActionTypes.setFileLoader);

  export type ClearLoader = ReturnType<typeof clearLoader>;
  export type SetDefaultLoader = ReturnType<typeof setDefaultLoader>;
  export type SetFileLoader = ReturnType<typeof setFileLoader>;

  export type Actions = ClearLoader | SetFileLoader | SetDefaultLoader;
}
